
import Vue from "vue"
import { mapGetters } from "vuex"
import { UserNavLink, isPathBelongsToLink } from "@/utils/user-nav"

export default Vue.extend({
  data: () => ({
    isMenuOpen: false,
  }),

  computed: {
    ...mapGetters("user", ["nav"]),

    currLink (): UserNavLink | null {
      const currLink = this.nav.find(
        (link: UserNavLink) => isPathBelongsToLink(link, this.$route.path),
      )

      return currLink || null
    },
  },

  mounted () {
    document.addEventListener("click", this.onDocumentClick)
  },

  beforeDestroy () {
    document.removeEventListener("click", this.onDocumentClick)
  },

  methods: {
    onDocumentClick (event: MouseEvent) {
      const menuRef = this.$refs.menuRef as HTMLDivElement
      if (!menuRef) return

      const target = event.target as Element
      if (!target) return

      const currLinkRef = this.$refs.currLinkRef as HTMLButtonElement
      if (!currLinkRef) return

      if (currLinkRef.contains(target)) return

      if (!menuRef.contains(target))
        this.isMenuOpen = false
    },
  },
})
